import { getProductData, utils } from '@hh/global.js'
const { throttle } = utils

class FixedATC extends HHBaseElement {
  constructor() {
    super()

    this.footer = document.querySelector('footer')
    this.addToCartToggle = this.querySelector(
      '.fixed-add-to-cart__button-container button'
    )

    this.productDetailsSection = document.querySelector(
      '.single-product__content'
    )

    this.mobileSticky = document.querySelector('.atc-container.mobile-sticky')
    this.mobileAddToCartButton = document.querySelector('.sticky-container')

    this._addToCart = this._addToCart.bind(this)
    this._throttleScroll = throttle((e) => {
      this._handleScrolling(e)
    }, 100)
    this._onScroll = this._throttleScroll.bind(this)
    this._clearMobileStyles = this._clearStickyStyles.bind(this)

    this.mql = window.matchMedia('(min-width: 992px)')
  }

  connectedCallback() {
    this._attachListeners()
    this._handleScrolling()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  _attachListeners() {
    document.addEventListener('scroll', this._onScroll, {
      passive: true,
    })
    if (this.addToCartToggle) {
      this.addToCartToggle.addEventListener('click', this._addToCart)
    }

    window.addEventListener('resize', this._clearMobileStyles)
  }

  _removeListeners() {
    document.removeEventListener('scroll', this._onScroll)

    window.removeEventListener('resize', this._clearMobileStyles)
    if (this.addToCartToggle) {
      this.addToCartToggle.removeEventListener('click', this._addToCart)
    }
  }

  _handleScrolling(e) {
    let footer = this.footer
    let footerDistanceFromTop =
      window.scrollY + footer.getBoundingClientRect().top

    if (this.mql.matches) {
      let scrolling = false
      let productDetailsSection = this.productDetailsSection

      footerDistanceFromTop -= footer.offsetHeight

      if (!scrolling) {
        window.requestAnimationFrame(() => {
          let pdpDetailsDistanceFromTop =
            window.scrollY +
            productDetailsSection.getBoundingClientRect().top +
            productDetailsSection.offsetHeight / 4

          if (
            window.scrollY > pdpDetailsDistanceFromTop &&
            window.scrollY < footerDistanceFromTop
          ) {
            this.classList.add('is-visible')
          } else {
            this.classList.remove('is-visible')
          }

          scrolling = false
        })

        scrolling = true
      }
    } else {
      let scrolling = false

      if (!scrolling) {
        window.requestAnimationFrame(() => {
          const isPastFooter = window.scrollY > footerDistanceFromTop

          if (isPastFooter) {
            this.mobileAddToCartButton.classList.add('is-offscreen')
          } else {
            this.mobileAddToCartButton.classList.remove('is-offscreen')
          }

          scrolling = false
        })

        scrolling = true
      }
    }
  }

  _clearStickyStyles() {
    if (this.mql.matches) {
      this.mobileAddToCartButton.classList.remove('is-sticky')
      this.mobileAddToCartButton.classList.remove('is-offscreen')

      this.style.transform = 'translate3d(0, 100%, 0)'
    }
  }

  get productId() {
    return this.getAttribute('product-id')
  }

  get product() {
    return (this._product ??= getProductData(this.productId, this, 'pdp'))
  }

  fillNotifyMeModal(params) {
    const notifyMeImage = document.querySelector('.js-slideout-notify-me-image')
    const notifyMeTitle = document.querySelector('.js-slideout-notify-me-title')
    const notifyMeVariant = document.querySelector(
      '.js-slideout-notify-me-variant'
    )
    const notifyMeSku = document.querySelector('#slideout-notify-me-sku')
    const notifyMeProductId = document.querySelector(
      '#slideout-notify-me-product-id'
    )

    notifyMeImage.innerHTML = `<img src="${params.image}" alt="${params.productTitle}" />`
    notifyMeTitle.innerHTML = params.productTitle
    if (params.title.toLowerCase() === 'default title') {
      notifyMeVariant.innerHTML = ''
    } else {
      let swatchHTML = ''

      // Prioritize swatch image over hex codes
      if (params.swatchImage) {
        swatchHTML = `
          <div class="color-select-inner">
            <div class="swatch-color-grid grid-1">
              <span style="background-image: url(${params.swatchImage}); background-size: cover;"></span>
            </div>
          </div>
        `
      } else if (params.hexCode) {
        const hexCodes = params.hexCode.split(',').map(code => code.trim())
        if (hexCodes.length >= 1 && hexCodes[0]) {
          swatchHTML = `
            <div class="color-select-inner">
              <div class="swatch-color-grid grid-${hexCodes.length}">
                ${hexCodes.map(color => `<span style="background-color: ${color};"></span>`).join('')}
              </div>
            </div>
          `
        }
      }

      notifyMeVariant.innerHTML = `${swatchHTML}${params.title}`
    }
    notifyMeSku.value = params.sku
    notifyMeProductId.value = params.productId
    const notifyMeVariantId = document.querySelector('#slideout-notify-me-variant-id')
    if (notifyMeVariantId) notifyMeVariantId.value = params.variantId
  }

  async _addToCart(e) {
    e.preventDefault()
    const triggerButton = e.currentTarget

    let selectedVariantId = document.querySelector('.selected-variant')
    const hexcode = document.querySelector('.js-selected-variant-hex')
    const swatchImageInput = document.querySelector('.js-selected-variant-swatch-image')

    const isNotifyMe =
      triggerButton.classList.contains(atcStatusTitle.notifyMeClass[0]) === true
    if (isNotifyMe) {
      let selectedItem = null
      this.product.variants.forEach((item) => {
        if (Number(selectedVariantId.value) === item.id) {
          selectedItem = item
        }
      })
      const params = {
        productId: this.product.id,
        variantId: selectedVariantId.value,
        productTitle: document.querySelector('.product-header__product-title')
          .innerHTML,
        sku: selectedItem?.sku,
        title: selectedItem?.title,
        image: selectedItem?.featured_image
          ? selectedItem?.featured_image.src
          : this.product.featured_image,
        hexCode: hexcode?.value,
        swatchImage: swatchImageInput?.value || '',
      }
      this.fillNotifyMeModal(params)
    } else {
      if (triggerButton) {
        triggerButton.setAttribute('loading', true)
      }
      const payload = {
        id: selectedVariantId.value,
        quantity: 1,
      }
      if (hexcode) {
        payload['properties'] = {}
        payload['properties']['hex'] = hexcode.value
      }

      try {
        await window.__CART__CONTROLLER__.add({
          payload,
        })
      } finally {
        triggerButton.removeAttribute('loading')
      }
    }
  }
}
window.customElements.define('fixed-atc', FixedATC)
